{
  "addDevice": {
    "addButton": "Додати пристрій",
    "description": "Потрібен лише серійний номер пристрою.",
    "successDescription": "Пристрій зареєстровано. Збережіть серійний номер та токен у безпечному місці.",
    "successTitle": "Пристрій успішно створено",
    "title": "Додати новий пристрій"
  },
  "app": {
    "title": "Wonder Forest"
  },
  "auth": {
    "loggingIn": "Вхід...",
    "login": "Вхід",
    "loginButton": "Увійти",
    "loginError": "Невірні облікові дані",
    "password": "Пароль",
    "username": "Ім'я користувача"
  },
  "analytics": {
    "title": "Аналітика",
    "filters": "Фільтри",
    "selected": "вибрано",
    "selectAll": "Вибрати всі",
    "deselectAll": "Скасувати вибір",
    "selectDevices": "Виберіть пристрої...",
    "sunburstTitle": "Аналітика виявлень",
    "selectDevicesToView": "Виберіть пристрої для перегляду аналітики",
    "deviceAvailability": {
      "title": "Доступність пристроїв",
      "description": "Частка періоду, протягом якої кожен вибраний пристрій мав відкрите з'єднання з платформою.",
      "loading": "Завантаження доступності...",
      "failed": "Не вдалося завантажити доступність пристроїв.",
      "retry": "Повторити",
      "retrying": "Повторення...",
      "narrowPeriod": "Забагато історії підключень для відображення. Звузьте період.",
      "noAccess": "Немає доступу до одного з вибраних пристроїв.",
      "notFound": "Одного з вибраних пристроїв більше не існує.",
      "timelineLabel": "Хронологія доступності {label}",
      "empty": "Немає пристроїв для відображення.",
      "noData": "Немає даних про доступність за цей період.",
      "average": "Середня доступність: {value}",
      "worst": "Найнижча: {label} ({value})",
      "disconnects": "Розриви зв'язку",
      "downtime": "Час простою",
      "longestDowntime": "Найдовший простій",
      "needsDevices": "Виберіть принаймні один пристрій.",
      "needsFrom": "Вкажіть початок періоду.",
      "tooManyDevices": "Виберіть не більше {max} пристроїв.",
      "fromInFuture": "Початок періоду має бути в минулому.",
      "toBeforeFrom": "Кінець періоду має бути пізніше за його початок.",
      "rangeTooLong": "Період не може перевищувати {max} дн."
    },
    "suppressionsReport": {
      "title": "Звіт про подавлення",
      "description": "Завантажує CSV з усіма подавленнями вибраних пристроїв за період, незалежно від статусу.",
      "download": "Завантажити CSV",
      "downloading": "Завантаження...",
      "needsDevices": "Виберіть принаймні один пристрій.",
      "needsFrom": "Вкажіть початок періоду.",
      "fromInFuture": "Початок періоду ще не настав.",
      "tooManyDevices": "Виберіть не більше {max} пристроїв.",
      "toBeforeFrom": "Кінець періоду має бути пізніше за його початок.",
      "rangeTooLong": "Період не може перевищувати {max} днів.",
      "tooManyRows": "Забагато подавлень для експорту ({rows}, ліміт {maxRows}). Звузьте період або набір пристроїв.",
      "tooManyRowsAtExport": "Забагато подавлень для експорту. Звузьте період або набір пристроїв.",
      "failed": "Не вдалося завантажити звіт."
    }
  },
  "common": {
    "apply": "Застосувати",
    "cancel": "Скасувати",
    "close": "Закрити",
    "delete": "Видалити",
    "edit": "Редагувати",
    "error": "Помилка",
    "loading": "Завантаження...",
    "next": "Наступна",
    "previous": "Попередня",
    "reset": "Скинути",
    "retry": "Повторити",
    "save": "Зберегти",
    "saving": "Зберігаю...",
    "submit": "Надіслати",
    "success": "Успіх",
    "unexpectedError": "Неочікувана помилка",
    "unknownError": "Невідома помилка"
  },
  "detectionGroups": {
    "eventsTab": "Події",
    "eventsLoading": "Завантаження подій…",
    "eventsError": "Не вдалося завантажити події",
    "eventsEmpty": "У цій групі немає подій."
  },
  "detections": {
    "allModes": "Всі режими",
    "devices": "Пристрої",
    "error": "Не вдалося завантажити виявлення",
    "errorLoadingDevices": "Помилка завантаження пристроїв",
    "visualize": "Аналітика",
    "expandToLoad": "Розгорніть для завантаження виявлень…",
    "failedToLoad": "Не вдалося завантажити виявлення",
    "filter": {
      "fromDate": "Початок дати",
      "toDate": "Кінець дати"
    },
    "loading": "Завантаження виявлень...",
    "loadingDetections": "Завантаження виявлень…",
    "loadingDevices": "Завантаження пристроїв...",
    "noDetectionsForDevice": "Немає виявлень для цього пристрою.",
    "noDevicesAvailable": "Немає доступних пристроїв.",
    "suppress": "Подавити",
    "suppressionMode": "Режим подавлення",
    "related": {
      "title": "Повʼязані пристрої",
      "noRelatedDevices": "Немає доступних повʼязаних пристроїв.",
      "compactTitle": "Виявлення повʼязаного пристрою - {serial}",
      "loading": "Завантаження виявлень повʼязаного пристрою…",
      "failedToLoad": "Не вдалося завантажити виявлення повʼязаного пристрою",
      "noGroups": "Для цього пристрою немає виявленнь.",
      "suppressOnMain": "Подавити",
      "suppressionCreated": "Подавлення створено з {serial} на {frequency} МГц."
    },
    "table": {
      "bandwidth": "Смуга, МГц",
      "count": "Кількість",
      "details": "Деталі",
      "motion": "Рух",
      "identity": "Клас",
      "confidenceShort": "Впевн.",
      "trackPending": "Дані трекінгу очікуються",
      "track": {
        "avgLevel": "Серед. рівень",
        "avgSnr": "Серед. SNR",
        "levelSlope": "Нахил рівня",
        "snrSlope": "Нахил SNR",
        "detectionRate": "Частота виявлень",
        "suppressionCount": "Подавлень",
        "signalMetrics": "Метрики сигналу",
        "identityNote": "На основі історії подавлень та стабільності сигналу"
      },
      "direction": "Напрямок",
      "directions": {
        "unknown": "Невідомо",
        "approaching": "Наближається",
        "receding": "Віддаляється"
      },
      "motionDirections": {
        "unknown": "Невідомо",
        "approaching": "Наближається",
        "receding": "Віддаляється",
        "static": "Статичний"
      },
      "identityRules": {
        "unknown": "Невідомо",
        "hostile": "Ворожий",
        "friendly": "Свій",
        "neutral": "Нейтральний"
      },
      "frequency": "Частота, МГц",
      "lastSeen": "Останнє виявлення",
      "timestamp": "Час виявлення",
      "offset": "Зсув, МГц",
      "pattern": "Шаблон",
      "showing": "Показано {start}–{end} з {total}",
      "signalLevel": "Рівень сигналу, дБ",
      "snr": "SNR, дБ",
      "status": "Статус",
      "type": "Тип",
      "window": "Вікно",
      "actions": "Дії",
      "startSuppression": "Подавити",
      "priority": "Пріоритет",
      "suppressionDuration": "Тривалість (сек)",
      "suppressionBandwidth": "Ширина (МГц)",
      "secondsSuffix": "сек",
      "mhzSuffix": "МГц",
      "stopSuppression": "Зупинити",
      "editFrequency": "Редагувати частоту",
      "changeFrequency": "Змінити",
      "changingFrequency": "Зміна...",
      "changeFrequencyConfirm": {
        "title": "Змінити частоту подавлення",
        "description": "Це зупинить поточне подавлення на {oldFrequency} МГц і почне нове на {newFrequency} МГц із початковим часом. Ви впевнені?"
      },
      "expandChildren": "Розгорнути дочірні",
      "repeatSuppression": "Повторити подавлення",
      "repeatSuppressionTooltipOffline": "Пристрій має бути онлайн, щоб повторити подавлення",
      "repeatSuppressionTooltipLoading": "Налаштування пристрою ще завантажуються",
      "repeatSuppressionTooltipUnavailable": "Налаштування пристрою недоступні",
      "repeatSuppressionFailed": "Не вдалося повторити подавлення"
    },
    "title": "Виявлення - {deviceSerialNumber}",
    "multiFrequency": {
      "badge": "Мультичастотне",
      "badgeTooltip": "Мультичастотне подавлення на {count, plural, one {# частоті} few {# частотах} many {# частотах} other {# частотах}}",
      "badgeTooltipUnknown": "Мультичастотне подавлення",
      "frequencies": "Частоти подавлення ({count})",
      "signalType": "Тип сигналу",
      "bandwidth": "Смуга",
      "bandwidthValue": "{value} МГц",
      "stepStandingTime": "Час утримання кроку",
      "stepStandingTimeValue": "{value} мс",
      "duration": "Тривалість",
      "durationValue": "{value} с",
      "startedAt": "Час початку",
      "finishedAt": "Час завершення",
      "unavailable": "Деталі подавлення недоступні",
      "stopTooltip": "Зупинити мультичастотне подавлення",
      "stopTooltipOffline": "Пристрій має бути онлайн, щоб зупинити мультичастотне подавлення",
      "stopFailed": "Не вдалося зупинити мультичастотне подавлення",
      "stopFailedDeviceOffline": "Пристрій офлайн — мультичастотне подавлення не зупинено",
      "stopFailedDeviceNotFound": "Пристрій не знайдено — мультичастотне подавлення не зупинено",
      "repeat": "Повторити мультичастотне подавлення",
      "repeatTooltipOffline": "Пристрій має бути онлайн, щоб повторити мультичастотне подавлення",
      "repeatTooltipNoSnapshot": "Деталі подавлення недоступні — неможливо повторити",
      "repeatFailed": "Не вдалося повторити мультичастотне подавлення"
    }
  },
  "deviceCard": {
    "activeSuppressions": {
      "label": "Активні подавлення: {count}",
      "offlinePrefix": "Пристрій офлайн — останні відомі подавлення",
      "kind": {
        "regular": "Звичайне",
        "broadband": "Широкосмугове"
      },
      "frequency": "{value} МГц",
      "frequencyRange": "{start}–{stop} МГц",
      "frequencyList": "{count} частот",
      "remaining": "лишилося {remaining}",
      "startedAt": "почато о {time}"
    },
    "control": "Керувати",
    "copySerial": "Копіювати серійний номер",
    "copyToken": "Копіювати токен",
    "details": "Деталі",
    "deviceMustBeOnline": "Пристрій має бути онлайн для подавлення",
    "deviceSettings": "Налаштування пристрою",
    "firmware": "Прошивка",
    "hideToken": "Приховати токен",
    "lastSeen": "Востаннє в мережі",
    "observer": "Спостерігач",
    "openEmulator": "Відкрити емулятор",
    "viewEvents": "Журнал подій",
    "popupBlocked": "Спливаюче вікно заблоковано! Будь ласка, дозвольте спливаючі вікна для цього сайту та спробуйте знову.",
    "hideOnMap": "Сховати на карті",
    "showOnMap": "Показати на карті",
    "showToken": "Показати токен",
    "suppress": "Подавити",
    "suppressSignals": "Подавити сигнали",
    "txDisabled": "TX вимкнено",
    "txEnabled": "TX увімкнено",
    "unknownModel": "Невідома модель"
  },
  "deviceTelemetry": {
    "button": "Телеметрія",
    "title": "Телеметрія – {serial}",
    "filters": {
      "metrics": "Метрики",
      "selectMetrics": "Оберіть метрики...",
      "fromDate": "Від",
      "toDate": "До",
      "refreshInterval": "Оновлення",
      "intervals": {
        "30000": "30 секунд",
        "60000": "1 хвилина",
        "300000": "5 хвилин",
        "600000": "10 хвилин",
        "1800000": "30 хвилин"
      }
    },
    "chart": {
      "noData": "Немає даних за цей період",
      "loading": "Завантаження..."
    },
    "metrics": {
      "power_supply_voltage": "Напруга від блоку живлення 220В",
      "battery_voltage": "Напруга акумулятора",
      "power_amplifier_1_current": "Струм підсилювач 1",
      "power_amplifier_2_current": "Струм підсилювач 2",
      "power_amplifier_1_temperature": "Температура підсилювач 1",
      "power_amplifier_2_temperature": "Температура підсилювач 2",
      "device_temperature": "Температура пристрою",
      "device_humidity": "Вологість пристрою",
      "cpu_temperature": "Температура CPU",
      "cpu_usage": "Завантаження CPU",
      "memory_usage": "Використання пам'яті",
      "bridge_temperature": "Температура мосту"
    },
    "units": {
      "volt": "В",
      "ampere": "А",
      "degree_celsius": "°C",
      "percent": "%"
    }
  },
  "deviceEvents": {
    "title": "Журнал подій — {serial}",
    "description": "Історія подій пристрою",
    "filters": {
      "messageType": "Тип повідомлення",
      "allTypes": "Усі типи",
      "fromDate": "Створені після",
      "toDate": "Створені до",
      "apply": "Застосувати фільтри",
      "reset": "Скинути фільтри"
    },
    "table": {
      "timestamps": "Час",
      "messageType": "Тип повідомлення",
      "errors": "Помилки",
      "payload": "Вміст"
    },
    "version": "Версія",
    "messageInitiatedAt": "Повідомлення ініційовано",
    "clockSkew": "Годинник пристрою відрізняється від серверного",
    "eventId": "ID події",
    "acknowledged": "Підтверджено",
    "waitingAck": "Очікує ACK",
    "noAck": "Очікується",
    "loading": "Завантаження подій...",
    "failedToLoad": "Не вдалося завантажити події",
    "noEvents": "Для цього пристрою ще немає подій",
    "pagination": "Показано {start}–{end} з {total} подій",
    "refreshing": "Оновлення…",
    "messageTypes": {
      "channels_table": "Таблиця каналів",
      "device_config": "Конфігурація пристрою",
      "device_settings": "Налаштування пристрою",
      "device_settings_update": "Оновлення налаштувань пристрою",
      "device_telemetry": "Телеметрія пристрою",
      "detections": "Виявлення",
      "forced_suppression": "Примусове подавлення",
      "frequency_whitelist_update": "Оновлення білого списку частот",
      "get_suppressions_queue": "Запит черги подавлень",
      "stop_suppression": "Зупинка подавлення",
      "suppressions": "Подавлення",
      "suppressions_queue": "Черга подавлень",
      "update_firmware": "Оновлення прошивки",
      "update_firmware_status": "Статус оновлення прошивки"
    }
  },
  "deviceCreated": {
    "close": "Закрити",
    "copy": "Копіювати",
    "serial": "Серійний номер",
    "successMessage": "Пристрій успішно зареєстровано!",
    "token": "Токен",
    "warning": "Збережіть ці облікові дані в безпечному місці. Токен більше не буде показано."
  },
  "deviceSettings": {
    "contactAdminForLocation": "Зверніться до адміністратора для оновлення налаштувань місцезнаходження та орієнтації.",
    "description": "Налаштуйте та керуйте параметрами пристрою.",
    "device": "Пристрій",
    "fields": {
      "friendOrFoeMinCalculationTime": "Мінімальний час підрахунку (сек)",
      "friendOrFoeMaxCalculationTime": "Максимальний час підрахунку (сек)",
      "suppressionLogic": {
        "label": "Логіка подавлення",
        "values": {
          "all_detections": "Всі виявлення",
          "approaching_only": "Наближаються",
          "approaching_and_unknown": "Наближаються та невідомі"
        }
      },
      "suppressionMode": {
        "auto": {
          "label": "Авто",
          "description": "Автоматичне подавлення"
        },
        "disabled": {
          "label": "Вимкнено",
          "description": "Без подавлення"
        },
        "label": "Режим подавлення",
        "manual": {
          "label": "Ручний",
          "description": "Тільки ручне подавлення"
        }
      },
      "directionality": {
        "label": "Напрямленість",
        "circular": {
          "label": "Круговий"
        },
        "directional": {
          "label": "Направлений"
        }
      },
      "multiChannelsSuppress": {
        "label": "Багатоканальне подавлення",
        "1": "Один канал",
        "2": "Два канали",
        "3": "Три канали"
      },
      "maxSuppressionTime": "Максимальний час подавлення (сек)",
      "suppressionTime": "Час одного циклу подавлення (сек)",
      "suppressionMaxCount": "Максимальна кількість подавлень",
      "suppressionInitialDelay": "Затримка перед початком подавлення (сек)",
      "suppressionMinDetectionsCount": "Мінімальна кількість детекцій перед подавленням",
      "suppressionMinSnr": "Мінімальне значення SNR для подавлення",
      "suppressionAttemptDelay": "Затримка до наступних спроб подавлень (сек)",
      "txGainDecreaseLevel": "Рівень зниження посилення TX (дБ)",
      "txGainDecreaseLevelHelp": "Для тестування в приміщенні рекомендоване значення: 30-40",
      "jumperMode": "Режим стрибунця",
      "jumperModeHelp": "Дозволити сеанси стрибунця для цього пристрою. Якщо вимкнено, нові сеанси стрибунця запустити неможливо.",
      "sapientEnabled": "Інтеграція SAPIENT",
      "detectionLifetime": "Затримка групування детекцій (сек)",
      "detectionLifetimeHelp": "Затримка між групами виявлень сигналів, щоб розглядати це як окремі цілі",
      "minAllowedFrequency": "Мінімальна дозволена частота (МГц)",
      "maxAllowedFrequency": "Максимальна дозволена частота (МГц)",
      "defaultAnalogSuppressionBandwidth": "Стандартна ширина смуги подавлення (аналог) (МГц)",
      "defaultDigitalSuppressionBandwidth": "Стандартна ширина смуги подавлення (цифра) (МГц)",
      "defaultAnalogMultiFrequencySuppressionBandwidth": "Стандартна ширина смуги подавлення (мультичастота, аналог) (МГц)",
      "defaultDigitalMultiFrequencySuppressionBandwidth": "Стандартна ширина смуги подавлення (мультичастота, цифра) (МГц)",
      "defaultMultiFrequencySuppressionSignalType": "Тип сигналу за замовчуванням для багаточастотного придушення",
      "defaultBroadbandSuppressionMode": {
        "label": "Режим широкосмугового подавлення за замовчуванням",
        "solid": {
          "label": "Суцільне"
        },
        "hopping": {
          "label": "Широкосмугове"
        }
      },
      "latitude": "Широта",
      "longitude": "Довгота",
      "azimuth": "Азимут (градуси)",
      "elevation": "Висота (метри)",
      "tags": "Теги",
      "model": "Модель",
      "modelUnknown": "Невідомо",
      "currentFirmwareVersion": "Поточна версія",
      "firmwareVersionUnknown": "Невідомо",
      "firmwareUpdateTo": "Оновити до {version}",
      "firmwareUpdating": "Оновлення...",
      "firmwareStatus": {
        "downloading_started": "Завантаження прошивки {version}...",
        "downloading_finished": "Прошивку {version} успішно завантажено",
        "downloading_failed": "Не вдалося завантажити прошивку: {reason}",
        "started": "Встановлення прошивки {version}...",
        "finished": "Прошивку оновлено до {version}",
        "failed": "Помилка оновлення прошивки: {reason}"
      },
      "deviceType": {
        "label": "Тип пристрою",
        "detector": {
          "label": "Детектор",
          "description": "Тільки виявлення, без можливості подавлення"
        },
        "detector_suppressor": {
          "label": "Детектор-подавлювач",
          "description": "Можливості виявлення та подавлення"
        }
      },
      "alertPatterns": "Шаблони сповіщень"
    },
    "scanRanges": {
      "addChannel": "Додати канал",
      "addRange": "Додати діапазон",
      "band": "Діапазон",
      "bandLabel": "Діапазон",
      "capabilityMissing": "Цей пристрій не підтримує діапазони сканувань.",
      "cancel": "Скасувати",
      "channel": "Канал",
      "channels": "Канали",
      "clear": "Очистити",
      "description": "Налаштування частотних каналів та діапазонів для цього пристрою",
      "digital": "Цифровий",
      "enabled": "Увімкнено",
      "endFreq": "Кінець (МГц)",
      "freqMhz": "Частота (МГц)",
      "genericSubmitError": "Не вдалося оновити діапазони сканувань.",
      "group": "Група",
      "import": "Імпорт",
      "importError": "Не вдалося імпортувати таблицю частот. Будь ласка, перевірте формат файлу.",
      "loadError": "Не вдалося завантажити таблицю частот",
      "loading": "Завантаження таблиці частот...",
      "noChannels": "Канали не налаштовані",
      "noRanges": "Діапазони не налаштовані",
      "ranges": "Діапазони сканувань",
      "save": "Зберегти зміни",
      "startFreq": "Початок (МГц)",
      "step": "Крок (МГц)",
      "title": "Діапазони сканувань"
    },
    "loadError": "Не вдалося завантажити налаштування",
    "loading": "Завантаження налаштувань пристрою…",
    "saving": "Збереження…",
    "sections": {
      "detection": {
        "title": "Налаштування виявлення",
        "description": "Налаштуйте параметри виявлення та діапазони частот"
      },
      "general": {
        "title": "Загальні налаштування",
        "description": "Налаштуйте поведінку подавлення та параметри виявлення"
      },
      "location": {
        "title": "Місцезнаходження та орієнтація",
        "description": "Встановіть географічне положення пристрою та орієнтацію антени"
      },
      "testing": {
        "title": "Тестування",
        "description": "Налаштуйте параметри для тестування пристрою"
      },
      "tags": {
        "title": "Теги",
        "description": "Керуйте тегами пристрою для організації та фільтрації"
      },
      "linkedDevices": {
        "title": "Пов'язані пристрої",
        "description": "Прив'яжіть додаткові Квітки до даного комплексу щоб отримувати більше детекцій з сусідніх комплексів"
      },
      "friendOrFoe": {
        "title": "Свій/Чужий",
        "description": "Керуйте логікою підрахунку визначення свій/чужий"
      },
      "device": {
        "title": "Пристрій",
        "description": "Інформація про модель пристрою та прошивку"
      },
      "alertPatterns": {
        "title": "Шаблони сповіщень",
        "description": "Назви шаблонів сповіщень, які відстежує цей пристрій. Назви зберігаються в нижньому регістрі."
      }
    },
    "tabs": {
      "settings": "Налаштування",
      "whitelist": "Білий список",
      "scanRanges": "Діапазони сканувань"
    },
    "title": "Налаштування пристрою",
    "reboot": "Перезавантажити",
    "rebootConfirmation": "Ви впевнені, що хочете перезавантажити цей пристрій?",
    "unregister": "Видалити",
    "unregisterConfirmation": "Ви впевнені, що хочете видалити цей пристрій? Цю дію неможливо скасувати.",
    "unregisterDevice": "Видалити пристрій",
    "unregistering": "Видалення…",
    "alertPatterns": {
      "placeholder": "Введіть назву шаблону та натисніть Enter",
      "remove": "Видалити шаблон {pattern}"
    },
    "family": {
      "label": "Сімейство пристрою",
      "hint": "Оберіть сімейство, яке відповідає фізичному пристрою. Змінити його пізніше буде неможливо.",
      "hintNonAdmin": "Сімейство пристрою не задано. Попросіть адміністратора задати його, перш ніж змінювати налаштування.",
      "settingsLocked": "Задайте сімейство пристрою, щоб налаштувати параметри. Теги можна зберегти вже зараз.",
      "assignFailed": "Не вдалося задати сімейство пристрою. Спробуйте ще раз.",
      "confirmTitle": "Задати сімейство пристрою?",
      "confirmBody": "Задати сімейство {family}? Воно має відповідати фізичному пристрою, і змінити його пізніше буде неможливо.",
      "confirm": "Задати сімейство",
      "alreadySet": "Пристрій уже повідомив своє сімейство. Його налаштування тепер доступні."
    },
    "errors": {
      "familyRequired": "Задайте сімейство пристрою, перш ніж налаштовувати параметри. Нічого не збережено.",
      "profileNotReady": "Профіль пристрою ще не готовий. Нічого не збережено; спробуйте трохи згодом.",
      "saveFailed": "Не вдалося зберегти налаштування пристрою. Нічого не збережено."
    }
  },
  "deviceTags": {
    "addError": "Не вдалося додати тег",
    "alreadyAssigned": "Тег '{name}' вже призначений",
    "createLabel": "Створити {value}",
    "loadError": "Не вдалося завантажити теги",
    "loading": "Завантаження тегів…",
    "noTags": "Теги не призначені",
    "placeholder": "Додати тег…",
    "removeError": "Не вдалося видалити тег",
    "removeTag": "Видалити тег {name}",
    "maxReached": "Максимум {max} тегів на пристрій"
  },
  "deviceLinkedDevices": {
    "addError": "Не вдалося додати зв'язок між пристроями",
    "removeError": "Не вдалося видалити зв'язок між пристроями",
    "noLinkedDevices": "Немає пов'язаних пристроїв",
    "placeholder": "Додати пристрій…",
    "removeDevice": "Видалити пов'язаний пристрій {serial}",
    "noAvailableDevices": "Немає доступних пристроїв"
  },
  "userGrants": {
    "label": "Доступ до пристроїв",
    "noGrants": "Теги не призначені",
    "placeholder": "Знайдіть або створіть тег...",
    "createLabel": "Створити \"{value}\"",
    "alreadyAssigned": "{name} вже призначено",
    "removeTag": "Видалити тег {name}",
    "roleFor": "Роль для {name}",
    "role": {
      "operator": "Оператор",
      "observer": "Спостерігач"
    },
    "footnote": "Доступ діє на кожен пристрій із цим тегом. Спостерігач переглядає; оператор також керує.",
    "maxReached": "Максимум {max} тегів на користувача",
    "maxLength": "Назва тегу має містити не більше 64 символів",
    "createError": "Не вдалося створити тег",
    "columnTag": "Тег",
    "columnRole": "Роль",
    "defaultRoleHint": "Спостерігач за замовчуванням",
    "deviceCount": "{count, plural, one {# пристрій} few {# пристрої} many {# пристроїв} other {# пристроїв}}",
    "summaryTagsOnly": "{tags, plural, one {# тег} few {# теги} many {# тегів} other {# тегів}}",
    "summary": "{tags, plural, one {# тег} few {# теги} many {# тегів} other {# тегів}} · {devices, plural, one {# пристрій} few {# пристрої} many {# пристроїв} other {# пристроїв}}"
  },
  "deviceWhitelist": {
    "addRange": "Додати діапазон",
    "allowedRange": "Дозволений діапазон: {min} - {max} МГц",
    "currentVersion": "Поточна версія: {version} ({date})",
    "description": "Керування дозволеними частотами для пристрою.",
    "fetchingRanges": "Завантаження збережених діапазонів…",
    "invalidEntry": "Невірний запис білого списку",
    "loadError": "Не вдалося завантажити білий список: {error}",
    "loadingDescription": "Завантаження даних білого списку для пристрою…",
    "maxFrequency": "Макс. частота: {max} МГц",
    "minFrequency": "Мін. частота: {min} МГц",
    "noLimits": "Обмеження частот не налаштовані",
    "noRanges": "Діапазони ще не додані.",
    "ranges": "Діапазони",
    "removeRange": "Видалити діапазон",
    "setError": "Не вдалося встановити білий список пристрою",
    "startMhz": "Початок, МГц",
    "stopMhz": "Кінець, МГц",
    "title": "{serial} - Білий список частот"
  },
  "devices": {
    "actions": "Дії",
    "addDevice": "Додати пристрій",
    "addDeviceDesc": "Потрібен лише серійний номер пристрою.",
    "addNewDevice": "Додати новий пристрій",
    "cancel": "Скасувати",
    "clearSelection": "Очистити вибір",
    "resizeMap": "Змінити розмір карти",
    "confirmDelete": "Видалити пристрій",
    "confirmDeleteDesc": "Ви впевнені, що хочете видалити пристрій {serial}? Цю дію неможливо скасувати.",
    "copySerial": "Копіювати серійний номер",
    "copyToken": "Копіювати токен",
    "create": "Створити",
    "creating": "Створення...",
    "delete": "Видалити",
    "deleting": "Видалення...",
    "deviceCreated": "Пристрій успішно створено",
    "deviceCreatedDesc": "Пристрій зареєстровано. Збережіть серійний номер та токен у безпечному місці.",
    "edit": "Редагувати",
    "error": "Не вдалося завантажити пристрої",
    "lastSeen": "Останній раз в мережі",
    "loading": "Завантаження пристроїв...",
    "map": "Карта",
    "noDevices": "Пристроїв не знайдено. Додайте свій перший пристрій, щоб почати.",
    "refresh": "Оновити",
    "refreshing": "Оновлення...",
    "serial": "Серійний номер",
    "serialCopied": "Серійний номер скопійовано в буфер обміну",
    "settings": "Налаштування",
    "status": "Статус",
    "title": "Пристрої",
    "tokenCopied": "Токен скопійовано в буфер обміну"
  },
  "devicesList": {
    "errorLoading": "Помилка завантаження пристроїв",
    "filterByTags": "Фільтрувати за тегами",
    "loadingDevices": "Завантаження пристроїв...",
    "noDevicesFound": "Пристроїв не знайдено",
    "noDevicesMatchingSerial": "Немає пристроїв, що відповідають '{query}'",
    "onlineOnly": "Тільки онлайн",
    "pagination": "Показано {start}–{end} з {total}",
    "perPage": "{count} на сторінці",
    "refresh": "Оновити",
    "refreshing": "Оновлення...",
    "serialSearchLabel": "Пошук за серійним номером",
    "serialSearchPlaceholder": "Пошук за серійним номером",
    "showAllOnMap": "Показати всі на карті ({count})",
    "showDevicesOnMap": "Показати {count} пристроїв на карті",
    "title": "Пристрої"
  },
  "map": {
    "azimuth": "Азимут",
    "coordinates": "Координати",
    "disabled": "Вимкнено",
    "elevation": "Elevation (meters)",
    "enabled": "Увімкнено",
    "lastSeen": "Останній раз в мережі",
    "status": {
      "online": "Онлайн",
      "offline": "Офлайн",
      "unknown": "Невідомо"
    },
    "tx": "TX"
  },
  "nav": {
    "alertSound": {
      "blockedHint": "Натисніть, щоб увімкнути звук сповіщень",
      "label": "Звук сповіщень",
      "off": "Звук сповіщень: вимкнено",
      "on": "Звук сповіщень: увімкнено"
    },
    "appName": "Wonder Forest",
    "analytics": "Аналітика",
    "devices": "Пристрої",
    "firmwares": "Прошивки",
    "loggingOut": "Вихід…",
    "logout": "Вийти",
    "profile": "Профіль",
    "users": "Користувачі"
  },
  "newDeviceForm": {
    "cancel": "Скасувати",
    "createDevice": "Створити пристрій",
    "createError": "Не вдалося створити пристрій. Спробуйте ще раз.",
    "creating": "Створення...",
    "serialNumber": "Серійний номер",
    "serialNumberPlaceholder": "Введіть серійний номер",
    "deviceType": "Тип пристрою",
    "deviceFamily": "Сімейство пристрою",
    "familyKvitka": "Квітка",
    "familyKvitkaDescription": "Детектор або детектор-подавлювач",
    "familySunflower": "Соняшник",
    "familySunflowerDescription": "Широкосмугове подавлення"
  },
  "profile": {
    "title": "Профіль",
    "username": "Ім'я користувача",
    "role": "Роль",
    "access": "Доступ",
    "createdAt": "Створено",
    "changePassword": {
      "title": "Змінити пароль",
      "currentPassword": "Поточний пароль",
      "newPassword": "Новий пароль",
      "confirmPassword": "Підтвердити новий пароль",
      "updateButton": "Оновити пароль",
      "updating": "Оновлення…",
      "successMessage": "Пароль успішно оновлено",
      "errorMessage": "Не вдалося змінити пароль"
    }
  },
  "signalType": {
    "analog": "Аналоговий",
    "digital": "Цифровий"
  },
  "suppressDialog": {
    "row": {
      "whitelistWarning": "Ця частота знаходиться в Білому списку"
    }
  },
  "suppressionsTable": {
    "duration": "Тривалість",
    "endedAt": "Кінець",
    "frequency": "Частота, МГц",
    "ongoing": "триває",
    "reason": "Причина",
    "seconds": "с",
    "startedAt": "Початок",
    "status": "Статус",
    "statusActive": "Активне",
    "statusEnded": "Завершено",
    "statusStopped": "Зупинено",
    "success": "Успіх",
    "type": "Тип"
  },
  "userDialog": {
    "action": {
      "cancel": "Скасувати",
      "creating": "Створюється...",
      "saving": "Зберігається...",
      "create": "Створити користувача",
      "save": "Зберегти зміни"
    },
    "field": {
      "username": "Ім'я користувача",
      "usernamePlaceholder": "ivan.petrenko",
      "usernameHint": "Дозволено: літери, цифри, крапка, дефіс, підкреслення.",
      "temporaryPassword": "Тимчасовий пароль",
      "resetPassword": "Скинути пароль",
      "passwordPlaceholder": "мінімум 6 символів",
      "passwordPlaceholderEdit": "залиште порожнім, щоб зберегти поточний пароль",
      "passwordHintEdit": "Заповніть, щоб встановити новий пароль, або залиште порожнім, щоб зберегти поточний.",
      "administrator": "Адміністратор",
      "administratorHint": "Адміністратор має доступ до всіх пристроїв."
    },
    "role": {
      "admin": "Адміністратор",
      "member": "Учасник"
    },
    "title": {
      "add": "Додати користувача",
      "edit": "Редагувати користувача"
    }
  },
  "users": {
    "accessDenied": "Доступ заборонено",
    "accessDeniedDesc": "У вас немає дозволу на перегляд цієї сторінки.",
    "actions": "Дії",
    "addNewUser": "Додати нового користувача",
    "addUser": "Додати користувача",
    "cancel": "Скасувати",
    "confirmDelete": "Видалити користувача",
    "confirmDeleteDesc": "Ви впевнені, що хочете видалити користувача {username}? Цю дію неможливо скасувати.",
    "createdAt": "Створено",
    "delete": "Видалити",
    "deleting": "Видалення...",
    "edit": "Редагувати",
    "editUser": "Редагувати користувача",
    "error": "Не вдалося завантажити користувачів",
    "loading": "Завантаження користувачів...",
    "loadingAccount": "Завантаження облікового запису...",
    "refresh": "Оновити",
    "refreshing": "Оновлення...",
    "role": "Роль",
    "noUserSelected": "Не вибрано жодного користувача",
    "save": "Зберегти",
    "saving": "Збереження...",
    "table": {
      "noUsers": "Немає доступних користувачів",
      "username": "Ім'я користувача",
      "access": "Доступ",
      "accessAdmin": "Адміністратор · усі пристрої",
      "created": "Створено",
      "updated": "Оновлено",
      "actions": "Дії",
      "editUser": "Редагувати користувача",
      "deleteUser": "Видалити користувача"
    },
    "title": "Користувачі",
    "username": "Ім'я користувача",
    "failedToSave": "Не вдалося зберегти користувача",
    "failedToDelete": "Не вдалося видалити користувача",
    "failedToLoad": "Не вдалося завантажити користувачів: {error}"
  },
  "detectionStatus": {
    "detected": "Виявлено",
    "suppressionSuccess": "Успішне",
    "suppressionFailed": "Не вдалося",
    "suppressionInitiated": "В черзі",
    "suppressionInProgress": "В процесі",
    "whitelisted": "У білому списку",
    "lost": "Пропущено",
    "unknown": "Невідомо"
  },
  "detectionsSunburst": {
    "detection": "детекція",
    "detections": "детекції",
    "noData": "Немає даних для візуалізаці",
    "visualizationTitle": "Аналітика подавлень - {serial}",
    "centerText": "від {totalCount} подавлень",
    "hoverPrompt": "Наведіть на сектор. Графік показує статистику {totalCount} подавлень груп детекцій.",
    "frequencyRanges": {
      "0-1": "0-1 ГГц",
      "1-2": "1-2 ГГц",
      "2-3": "2-3 ГГц",
      "3-4": "3-4 ГГц",
      "4-5": "4-5 ГГц",
      "5-6": "5-6 ГГц"
    },
    "stats": {
      "total": "Всього",
      "suppressed": "Успішне",
      "failed": "Не вдалося"
    },
    "statusFilter": {
      "title": "Статуси",
      "showing": "Показується {filtered} з {total}"
    }
  },
  "validation": {
    "required": "{field} є обов'язковим",
    "invalidNumber": "{field} має бути дійсним числом",
    "provideValidNumber": "Введіть коректне число",
    "mustBeInteger": "{field} має бути цілим числом",
    "mustBeAtLeast": "{field} має бути не менше {min}",
    "mustBeAtMost": "{field} має бути не більше {max}",
    "mustBeGreaterThan": "{field} має бути більше {min}",
    "mustBeLessThan": "{field} має бути менше {max}",
    "mustBeGreaterOrEqual": "{field} має бути більше або дорівнювати {min}",
    "mustBeLessOrEqual": "{field} має бути менше або дорівнювати {max}",
    "mustBePositive": "{field} має бути додатнім",
    "cannotExceed": "{field} не може перевищувати {max} символів",
    "allowedChars": "Дозволено: літери, цифри, крапка, дефіс, підкреслення.",
    "passwordsDoNotMatch": "Паролі не співпадають",
    "maxTags": "Можна призначити до {max} тегів",
    "maxGreaterThanMin": "{maxField} має бути більше ніж {minField}",
    "endGreaterThanStart": "Кінцева {field} має бути більше початкової {field}",
    "login": {
      "usernameRequired": "Ім'я користувача є обов'язковим",
      "passwordRequired": "Пароль є обов'язковим"
    },
    "device": {
      "serialNumberRequired": "Серійний номер є обов'язковим",
      "selectFamily": "Виберіть сімейство пристрою"
    },
    "deviceSettings": {
      "selectDeviceType": "Виберіть тип пристрою",
      "selectSuppressionMode": "Виберіть режим подавлення",
      "selectSuppressionLogic": "Виберіть логіку подавлення",
      "multiChannelsSuppressMin": "Багатоканальне подавлення має бути 0 або більше",
      "maxSuppressionTimeInvalid": "Максимальний час подавлення має бути дійсним числом",
      "maxSuppressionTimeMin": "Максимальний час подавлення має бути більше 0",
      "defaultAnalogSuppressionBandwidthInvalid": "Стандартна ширина смуги подавлення (аналог) має бути дійсним числом",
      "defaultAnalogSuppressionBandwidthMin": "Стандартна ширина смуги подавлення (аналог) має бути одним із значень: {options} МГц",
      "defaultDigitalSuppressionBandwidthInvalid": "Стандартна ширина смуги подавлення (цифра) має бути дійсним числом",
      "defaultAnalogMultiFrequencySuppressionBandwidthInvalid": "Стандартна ширина смуги подавлення (мультичастота, аналог) має бути дійсним числом",
      "defaultDigitalMultiFrequencySuppressionBandwidthInvalid": "Стандартна ширина смуги подавлення (мультичастота, цифра) має бути дійсним числом",
      "defaultDigitalSuppressionBandwidthMin": "Стандартна ширина смуги подавлення (цифра) має бути одним із значень: {options} МГц",
      "defaultAnalogMultiFrequencySuppressionBandwidthMin": "Стандартна ширина смуги подавлення (мультичастота, аналог) має бути одним із значень: {options} МГц",
      "defaultDigitalMultiFrequencySuppressionBandwidthMin": "Стандартна ширина смуги подавлення (мультичастота, цифра) має бути одним із значень: {options} МГц",
      "defaultMultiFrequencySuppressionSignalTypeInvalid": "Тип сигналу за замовчуванням для багаточастотного придушення має бути аналоговим або цифровим",
      "suppressionTimeMin": "Час подавлення має бути більше 0",
      "suppressionMaxCountMin": "Максимальна кількість подавлень має бути більше 0",
      "suppressionInitialDelayInvalid": "Початкова затримка подавлення має бути дійсним числом",
      "suppressionInitialDelayMin": "Початкова затримка подавлення має бути не менше 0",
      "suppressionMinDetectionsInvalid": "Мінімальна кількість детекцій має бути дійсним числом",
      "suppressionMinDetectionsMin": "Мінімальна кількість детекцій має бути більше 0",
      "suppressionMinDetectionsMax": "Мінімальна кількість детекцій має бути не більше 20",
      "suppressionMinSnrInvalid": "Мінімальне значення SNR має бути дійсним числом",
      "suppressionMinSnrMin": "Мінімальне значення SNR має бути більше 0",
      "suppressionMinSnrMax": "Мінімальне значення SNR має бути не більше 30",
      "azimuthInvalid": "Введіть коректний азимут",
      "azimuthMin": "Азимут має бути не менше 0",
      "azimuthMax": "Азимут має бути не більше 359.99",
      "elevationInvalid": "Введіть коректну висоту",
      "elevationMin": "Висота має бути не менше 0",
      "latitudeInvalid": "Введіть коректну широту",
      "latitudeMin": "Широта має бути не менше -90",
      "latitudeMax": "Широта має бути не більше 90",
      "longitudeInvalid": "Введіть коректну довготу",
      "longitudeMin": "Довгота має бути не менше -180",
      "longitudeMax": "Довгота має бути не більше 180",
      "detectionLifetimeInvalid": "Час групування детекції має бути дійсним числом",
      "detectionLifetimeMin": "Час групування детекції має бути більше 90",
      "minFrequencyInvalid": "Мінімальна дозволена частота має бути дійсним числом",
      "minFrequencyMin": "Мінімальна дозволена частота має бути більше 0",
      "maxFrequencyInvalid": "Максимальна дозволена частота має бути дійсним числом",
      "maxFrequencyMin": "Максимальна дозволена частота має бути більше 0",
      "maxFrequencyGreaterThanMin": "Максимальна дозволена частота має бути більше мінімальної дозволеної частоти",
      "suppressionAttemptDelayInvalid": "Затримка спроби подавлення має бути дійсним числом",
      "suppressionAttemptDelayMin": "Затримка спроби подавлення має бути не менше 0",
      "txGainInvalid": "Рівень зменшення TX підсилення має бути дійсним числом",
      "txGainMin": "Рівень зменшення TX підсилення має бути додатнім",
      "txGainMax": "Рівень зменшення TX підсилення має бути менше 60",
      "fofMinTimeInvalid": "Мінімальний час розрахунку Свій/Чужий має бути дійсним числом",
      "fofMinTimeMin": "Мінімальний час розрахунку Свій/Чужий має бути не менше 1 секунди",
      "fofMinTimeMax": "Мінімальний час розрахунку Свій/Чужий має бути менше 3600 секунд",
      "fofMaxTimeInvalid": "Максимальний час розрахунку Свій/Чужий має бути дійсним числом",
      "fofMaxTimeMin": "Максимальний час розрахунку Свій/Чужий має бути не менше 1 секунди",
      "fofMaxTimeMax": "Максимальний час розрахунку Свій/Чужий має бути менше 3600 секунд",
      "alertPatternsTooMany": "Можна додати до {max} шаблонів сповіщень",
      "alertPatternTooLong": "Кожен шаблон сповіщення має містити не більше {max} символів",
      "alertPatternsInvalid": "Шаблони сповіщень мають бути списком текстових значень"
    },
    "user": {
      "usernameMinLength": "Ім'я користувача має містити щонайменше 3 символи",
      "usernameFormat": "Дозволено: літери, цифри, крапка, дефіс, підкреслення.",
      "duplicateGrantTag": "Тег можна призначити лише один раз",
      "passwordMinLength": "Пароль має містити щонайменше 6 символів"
    },
    "password": {
      "currentMinLength": "Поточний пароль має містити щонайменше 6 символів",
      "newMinLength": "Новий пароль має містити щонайменше 6 символів",
      "confirmMinLength": "Підтвердження паролю має містити щонайменше 6 символів",
      "doNotMatch": "Паролі не співпадають"
    },
    "tag": {
      "nameRequired": "Назва тегу є обов'язковою",
      "nameMaxLength": "Назва тегу має містити не більше 64 символів"
    },
    "frequency": {
      "frequencyInvalid": "Частота має бути дійсним числом",
      "frequencyMin": "Частота має бути не менше {min} МГц",
      "frequencyMax": "Частота має бути не більше {max} МГц",
      "startInvalid": "Початкова частота має бути дійсним числом",
      "startMin": "Початкова частота має бути не менше {min} МГц",
      "startMax": "Початкова частота має бути не більше {max} МГц",
      "endInvalid": "Кінцева частота має бути дійсним числом",
      "endMin": "Кінцева частота має бути не менше {min} МГц",
      "endMax": "Кінцева частота має бути не більше {max} МГц",
      "endGreaterThanStart": "Кінцева частота має бути більше початкової частоти"
    },
    "scanRanges": {
      "bandRequired": "Діапазон є обов'язковим",
      "bandInvalid": "Діапазон має бути рядком",
      "bandMaxLength": "Діапазон не може перевищувати 120 символів",
      "groupRequired": "Група є обов'язковою",
      "groupInvalid": "Група має бути рядком",
      "groupMaxLength": "Група не може перевищувати 120 символів",
      "channelRequired": "Канал є обов'язковим",
      "channelInvalid": "Канал має бути числом",
      "channelInteger": "Канал має бути цілим числом",
      "channelMin": "Канал має бути 0 або більше",
      "stepRequired": "Крок є обов'язковим",
      "stepInvalid": "Крок має бути числом",
      "stepMin": "Крок має бути більше 0"
    },
    "suppression": {
      "bandwidthInvalid": "Ширина має бути дійсним числом",
      "bandwidthMin": "Ширина має бути не менше {min} МГц",
      "durationInvalid": "Тривалість має бути числом",
      "durationMax": "Тривалість має бути не більше {max}",
      "durationMin": "Тривалість має бути не менше 1",
      "durationRequired": "Тривалість є обов'язковою"
    },
    "firmware": {
      "versionRequired": "Версія є обов'язковою",
      "versionMaxLength": "Версія повинна містити не більше 32-ох символів",
      "versionFormat": "Версія повинна бути числом в форматі X.X.X",
      "fileRequired": "Файл прошивки є обов'язковим",
      "fileExtension": "Файл прошивки має бути в .bin, .hex, or .fw форматі",
      "fileSize": "Розмір файлу прошивки не повинен перевищувати 100 МБ"
    },
    "broadbandSuppression": {
      "bandwidthInvalid": "Ширина смуги має бути коректним цілим числом",
      "bandwidthRange": "Ширина смуги має бути в межах від {min} до {max}",
      "stepInvalid": "Крок має бути коректним цілим числом",
      "stepRange": "Крок має бути в межах від {min} до {max}",
      "stepStandingTimeInvalid": "Час утримання кроку має бути коректним цілим числом",
      "stepStandingTimeRange": "Час утримання кроку має бути в межах від {min} до {max}",
      "stepStandingTimeStep": "Час утримання кроку має ділитися на 5",
      "frequencyRangeMax": "Діапазон частот (кінець - початок) не має перевищувати {max} МГц",
      "frequencyListMin": "Додайте щонайменше дві частоти",
      "frequencyListMax": "Можна додати не більше {max} частот",
      "frequencyListUnique": "Частоти мають бути унікальними",
      "frequencySpanMax": "Діапазон між найнижчою та найвищою частотою не має перевищувати {max} МГц"
    },
    "jumper": {
      "durationInvalid": "Тривалість має бути цілим числом",
      "durationMin": "Тривалість має бути не менше {min} хв",
      "durationMax": "Тривалість не має перевищувати {max} хв",
      "spanMax": "Діапазон частот (кінець - початок) не має перевищувати {max} МГц",
      "suppressionTimeInvalid": "Час подавлення має бути цілим числом",
      "suppressionTimeMin": "Час подавлення має бути не менше {min} с",
      "suppressionTimeMax": "Час подавлення не має перевищувати {max} с",
      "suppressionMaxCountInvalid": "Макс. кількість подавлень має бути цілим числом",
      "suppressionMaxCountMin": "Макс. кількість подавлень має бути не менше {min}",
      "suppressionMaxCountMax": "Макс. кількість подавлень не має перевищувати {max}",
      "bandwidthInvalid": "Ширина завади має бути одним із дозволених значень"
    }
  },
  "firmwares": {
    "title": "Прошивки",
    "addFirmware": "Додати прошивку",
    "refresh": "Оновити",
    "refreshing": "Оновлення...",
    "loading": "Завантаження прошивок...",
    "loadingAccount": "Завантаження облікового запису...",
    "deleting": "Видалення...",
    "confirmDelete": "Видалити прошивку",
    "confirmDeleteDesc": "Ви впевнені, що хочете видалити прошивку версії {version}? Цю дію неможливо скасувати.",
    "failedToDelete": "Не вдалося видалити прошивку",
    "deviceModelsPlaceholder": "Виберіть моделі пристроїв...",
    "noDeviceModels": "Немає доступних моделей пристроїв",
    "accessDenied": {
      "title": "Доступ заборонено",
      "description": "У вас немає дозволу на перегляд цієї сторінки."
    },
    "error": {
      "failedToLoad": "Не вдалося завантажити прошивки: {error}",
      "failedToCreate": "Не вдалося створити прошивку"
    },
    "table": {
      "noFirmwares": "Прошивок не знайдено. Додайте першу прошивку, щоб почати.",
      "version": "Версія",
      "fileName": "Назва файлу",
      "fileSize": "Розмір",
      "deviceModels": "Моделі пристроїв",
      "devicesCount": "Пристрої",
      "createdAt": "Створено",
      "actions": "Дії",
      "deleteFirmware": "Видалити прошивку"
    },
    "dialog": {
      "title": "Додати прошивку",
      "description": "Завантажте файл прошивки для розгортання на ваших пристроях.",
      "version": "Версія",
      "versionPlaceholder": "1.0.0",
      "versionHint": "Використовуйте формат MAJOR.MINOR.PATCH (наприклад, 1.0.0, 2.1.3)",
      "file": "Файл прошивки",
      "dropzone": "Натисніть для вибору або перетягніть файл",
      "allowedFormats": ".bin, .hex, .fw (макс. 100 МБ)",
      "deviceModels": "Моделі пристроїв",
      "deviceModelsHint": "Виберіть моделі пристроїв, для яких призначена ця прошивка",
      "upload": "Завантажити прошивку",
      "uploading": "Завантаження..."
    }
  },
  "jumperSession": {
    "alert": {
      "label": "Активний сеанс джампера: {startMHz}–{endMHz} МГц",
      "viewDetails": "Деталі",
      "stop": "Зупинити"
    },
    "confirmStop": {
      "title": "Зупинити сеанс джампера",
      "body": "Ви впевнені, що хочете зупинити цей сеанс джампера? Цю дію не можна скасувати.",
      "cancel": "Скасувати",
      "confirm": "Зупинити сеанс"
    },
    "dialog": {
      "startFrequency": "Початкова частота",
      "endFrequency": "Кінцева частота",
      "duration": "Тривалість",
      "suppressionTime": "Час подавлення на одній частоті",
      "suppressionMaxCount": "Макс. кількість подавлень на одній частоті",
      "bandwidth": "Ширина завади",
      "submit": "Запустити",
      "submitting": "Запуск...",
      "genericSubmitError": "Не вдалося запустити сеанс джампера.",
      "capabilityMissing": "Цей пристрій не підтримує сеанси джампера."
    },
    "modal": {
      "title": "Активний сеанс джампера",
      "sessionEnded": "Сеанс завершено",
      "stop": "Зупинити сеанс",
      "linkedGroups": "Пов'язані групи детекцій",
      "empty": "Пов'язані групи детекцій не знайдено.",
      "initialBadge": "Початкова"
    }
  },
  "broadbandSuppressionsDialog": {
    "title": "Широкосмугове подавлення – {serial}",
    "actions": {
      "create": "Створити подавлення",
      "suppress": "Подавити",
      "stop": "Зупинити",
      "repeat": "Повторити подавлення",
      "repeatTooltipOffline": "Пристрій має бути онлайн, щоб повторити подавлення",
      "repeatTooltipIncomplete": "Це подавлення неможливо повторити — бракує параметрів",
      "repeatFailed": "Не вдалося повторити подавлення",
      "repeatFailedRejected": "Параметри подавлення відхилено",
      "repeatFailedDeviceNotFound": "Пристрій не знайдено",
      "repeatFailedForbidden": "Недостатньо прав, щоб повторити подавлення"
    },
    "form": {
      "signalType": "Тип сигналу",
      "type": {
        "analog": "Аналоговий",
        "digital": "Цифровий"
      },
      "tabs": {
        "regular": "Звичайне",
        "solid": "Суцільне",
        "hopping": "Широкосмугове",
        "multi": "Мультичастотне",
        "jumper": "Джампер"
      },
      "frequencyStart": "Початкова частота",
      "frequencyStop": "Кінцева частота",
      "bandwidth": "Ширина смуги",
      "step": "Крок",
      "stepStandingTime": "Час утримання кроку (мс)",
      "duration": "Тривалість (с)",
      "deviceOffline": "Пристрій офлайн",
      "creating": "Створення...",
      "submitError": "Не вдалося створити широкосмугове подавлення.",
      "genericCreating": "Створення...",
      "genericSubmitError": "Не вдалося створити подавлення.",
      "manual": {
        "frequency": "Частота",
        "offset": "Зсув"
      },
      "multi": {
        "frequency": "Частота",
        "frequencyPlaceholder": "Введіть частоту",
        "frequencyBadge": "{value} МГц",
        "addFrequency": "Додати частоту",
        "removeFrequencyValue": "Видалити частоту {value} МГц",
        "noFrequencies": "Частоти ще не додані"
      }
    },
    "table": {
      "status": "Статус",
      "frequency": "Частота",
      "detailsHeader": "Деталі",
      "frequencyStart": "Початок (МГц)",
      "frequencyStop": "Кінець (МГц)",
      "bandwidth": "Ширина смуги",
      "step": "Крок",
      "stepStandingTime": "Час утримання кроку (мс)",
      "duration": "Тривалість (с)",
      "createdAt": "Створено",
      "timestamps": "Дата і час",
      "detailLabels": {
        "step": "Крок: {value} МГц",
        "standingTime": "Утримання: {value} мс",
        "bandwidth": "Смуга: {value} МГц",
        "frequencies": "Частоти: {value} МГц"
      },
      "timestampLabels": {
        "created": "Створено",
        "started": "Почато",
        "finished": "Завершено"
      },
      "actions": "Дії",
      "draft": "Чернетка",
      "loading": "Завантаження широкосмугових подавлень...",
      "failedToLoad": "Не вдалося завантажити широкосмугові подавлення.",
      "empty": "Широкосмугових подавлень ще немає.",
      "pagination": "Показано {start}-{end} з {total}"
    },
    "status": {
      "initiated": "Ініційовано",
      "in_progress": "В процесі",
      "finished": "Завершено",
      "stopped": "Зупинено",
      "failed": "Не вдалося"
    }
  },
  "alerts": {
    "fallback": "Сповіщення пристрою ({source}/{type})",
    "indicatorLabel": "Активні сповіщення: {count}",
    "popover": {
      "label": "Активні сповіщення"
    },
    "acknowledge": {
      "action": "Підтвердити",
      "noLongerActive": "Сповіщення вже неактивне",
      "failed": "Не вдалося підтвердити сповіщення"
    },
    "params": {
      "frequencyMhz": "{value} МГц",
      "similarityPercent": "{value}%"
    },
    "pattern": {
      "pattern_detected": "Виявлено шаблон зі списку спостереження «{pattern}» на частоті {frequency}"
    }
  }
}
